document.addEventListener("DOMContentLoaded", function () {

    let lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

    if ("IntersectionObserver" in window) {
        let lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (video) {
                if (video.isIntersecting) {
                    window.setTimeout(() => {
                        let playPromise = video.target.play();
                        if (playPromise !== undefined) {
                            playPromise.then(function () {
                                // console.log('video started')
                                // Automatic playback started!
                            }).catch(function (error) {
                                // console.log('an error occurred')
                                // Automatic playback failed.
                                // Show a UI element to let the user manually start playback.
                            });
                        }
                    }, 3500);
                }
            });
        });

        lazyVideos.forEach(function (lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
        });
    }
});
